import React from 'react';
import { ImageProps } from './props.types';

export const Image = (props: ImageProps) => {
  return (
    <picture className={props.pictureClassName}>
      {props.srcs && props.srcs.map((item: any, key: any) => <source key={key} srcSet={item.src} type={item.type} />)}
      <img
        className={props.className}
        src={props.src}
        alt={props.alt}
        // onError={({ currentTarget }) => {
        //   currentTarget.onerror = null; // prevents looping
        //   currentTarget.src = '/public-assets/img/shared/nopicture.png';
        // }}
      />
    </picture>
  );
};
